export const AttachmentsListName = 'attachmentsList';
